package com.altmann.choresmanager.di

import org.koin.dsl.module

actual val targetModule = module {

}